function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgRedFlag = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  viewBox: "0 0 511.999 511.999",
  xmlSpace: "preserve",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
  style: {
    fill: "#E21B1B"
  },
  d: "M103.919,51.744c0,0,41.296,33.496,109.008,18.4c64.2-14.264,124.056-30.464,224.616,5.856v215.032 c0,0-92.488-44.104-176.736-24.432s-131.88,12.12-156.888-12.888"
}), /*#__PURE__*/React.createElement("rect", {
  x: 90.74,
  y: 37.524,
  style: {
    fill: "#999999"
  },
  width: 16,
  height: 474.475
}), /*#__PURE__*/React.createElement("circle", {
  style: {
    fill: "#666666"
  },
  cx: 98.741,
  cy: 24.284,
  r: 24.284
}));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgRedFlag, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/red-flag.4b0765f1.svg";
export { ForwardRef as ReactComponent };